<template>
  <div class="returnTop" @click="goTop" :style="{ opacity: topOpacity }">
    <OssImg class="returnImg" src="images/homeIcon13.png" alt="" />
  </div>
</template>

<script setup>
import { ref } from "vue";

const topOpacity = ref(0);

const showTop = () => {
  topOpacity.value = 1;
};

const hideTop = () => {
  topOpacity.value = 0;
};

const goTop = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth", // 平滑滚动
  });
};

defineExpose({
  showTop,
  hideTop,
});
</script>

<style lang="scss" scoped>
.returnTop {
  position: fixed;
  right: 3rem;
  top: 80vh;
  z-index: 999;
  padding: 1rem;
  border-radius: 1rem;
  background: #fff;
  opacity: 1;
  transition: opacity 0.5s;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 4px 10px #0000001a;

  .returnImg {
    width: 2rem;
    height: 2rem;
  }
}

// @media(max-width: 768px) {
//   .returnTop {
//     right: 1rem;
//     width: 5rem;
//     height: 5rem;
//   }
// }</style>
